class viewSeatplan {
    constructor($state) {
        this.key = 'view-seatplan';
        this.title = 'Details';
        this.level = 'row';
        this.state = $state;
    }

    action(payload, store) {
        return this.state.go('app.seatplans.details', {id: payload.row.id, store: store});
    }

}

angular
    .module('festzelt-os.seatplans')
    .factory('viewSeatplan', [
        '$state',
        $state => new viewSeatplan($state)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/seatplans/workflows/view-seatplan.js